import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import mainStyles from "styles";

interface ConfirmDialogProps {
  title: string;
  children?: React.ReactNode;
  open: boolean;
  disableBackgroundClick?: boolean;
  disabled?: boolean;
  disableCancelBtn?: boolean;
  cancelBtnLabel: string;
  confirmBtnLabel: string;
  width?: false | "sm" | "xs" | "md" | "lg" | "xl" | undefined;
  setOpen: (isOpen: boolean) => void;
  onClose?: (setOpen: boolean) => void;
  onConfirm: () => void;
  onCancel?: () => void;
  disableCloseOnConfirm?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title,
  children,
  open,
  disabled,
  disableCancelBtn,
  cancelBtnLabel,
  confirmBtnLabel,
  width,
  disableBackgroundClick,
  setOpen,
  onConfirm,
  onCancel,
  disableCloseOnConfirm,
  onClose,
}: ConfirmDialogProps) => {
  const classes = mainStyles();

  return (
    <Grid>
      <Dialog
        open={open}
        onClose={(_, reason) => {
          if (reason && reason == "backdropClick" && disableBackgroundClick)
            return;
          setOpen(false);
          if (onClose) onClose(false);
        }}
        aria-labelledby="confirm-dialog"
        fullWidth={true}
        maxWidth={width ? width : "sm"}
        data-testid="confirm-dialog"
      >
        <DialogTitle id="confirm-dialog" style={{ paddingBottom: "0" }}>
          <Grid container justifyContent="center">
            {title}
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container justifyContent="flex-start">
            {children}
          </Grid>
        </DialogContent>
        <DialogActions sx={classes.confirmDialogAction}>
          <Button
            variant="contained"
            onClick={() => {
              setOpen(false);
              if (onCancel) {
                onCancel();
              }
            }}
            color="secondary"
            data-testid="confirm-dialog-cancel"
            disabled={disableCancelBtn}
          >
            {cancelBtnLabel}
          </Button>
          <Button
            variant="contained"
            disabled={disabled}
            onClick={() => {
              // Closes modal when clicking confirm by default unless disableCloseOnConfirm is true
              if (!disableCloseOnConfirm) {
                setOpen(false);
              }
              onConfirm();
            }}
            color="primary"
            data-testid="confirm-dialog-submit"
          >
            {confirmBtnLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default ConfirmDialog;
